export enum BiddingType {
  Floor = 'floor',
  Automated = 'automated',
  Fixed = 'fixed',
}
